export default "__VITE_ASSET__D$I$NqSf__"